module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buttons":{"downloadReport":"Download report","changeDetails":"Change details"},"dialog":{"title":"Amend Details?","description":"Would you like to continue and change any information in your eligibility check?","cancel":"Cancel","continue":"Continue"}}}')
  delete Component.options._Ctor
}
